import React from "react";
import clsx from 'clsx';
import {
  Card,
  CardContent,
} from '@material-ui/core';
import PropTypes from 'prop-types';

import InfoPageHeader from "./components/info_page_header.js";

import I18n from "../../base/i18n.js";

import Button from "../../base/buttons/button.js";
import FormFields from "../../base/form/form_fields.js";

import NavigationTabContent from "./components/navigation_tab_content.js";

import Routes from "../routes.js";
import URLParams from "../../utils/url_params.js";

const infoPageStyles = theme => ({
  cardTitle: {
    fontWeight: theme.typography.fontWeightBold,
    fontSize: "21px",
    marginBottom: "14px"
  },
  pageDataCard: {
    overflow: "visible",
    marginBottom: "25px"
  },
  pageDataContent: {
    overflow: "visible",
    padding: "10px 16px"
  },
  form: {
    marginBottom: "60px"
  }
});

// TODO: Document it
class BaseInfoPage extends React.Component {

  constructor(props) {
    super(props);

    this.identifier = props.identifier;
    this.item = this.defaultItem();
    this.routeFunc = props.routeFunc;
    this.dataModel = props.dataModel;

    this.newUseCase    = props.newUseCase;
    this.showUseCase   = props.showUseCase;
    this.saveUseCase   = props.saveUseCase;
    this.deleteUseCase = props.deleteUseCase;

    let currentTab;
    if(window.location.hash) {
      const hash = window.location.hash.substring(1);
      currentTab = hash; 
    }

    this.state = {
      formFields: this.formFields(),
      loading: true,
      currentTab: currentTab
    }

    this.loadItem          = this.loadItem.bind(this);
    this.processDataLoader = this.processDataLoader.bind(this);

    this.onItemChange = this.onItemChange.bind(this);

    this.onSubmit = this.onSubmit.bind(this);

    this.beforeSaveProcessing = this.beforeSaveProcessing.bind(this);
    this.saveItem         = this.saveItem.bind(this);
    this.afterSaveSuccess = this.afterSaveSuccess.bind(this);
    this.afterSaveFail    = this.afterSaveFail.bind(this);

    this.onDelete          = this.onDelete.bind(this);
    this.onDeleteConfirmed = this.onDeleteConfirmed.bind(this);

    this.onChangeTab = this.onChangeTab.bind(this);
  }
  
  defaultItem() {
    return {
      id: this.identifier,
      key: "notLoadedItem"
    }
  }

  componentDidMount() {
    this.loadItem();
  }

  componentDidUpdate(prevProps, prevState) {
  }


  loadItem() {
    if(!this.identifier && this.newUseCase) {
      this.processDataLoader(this.newUseCase.execute());
    }
    else {
      this.processDataLoader(this.showUseCase.execute(this.identifier));
    }
  }

  processDataLoader(promise) {
    promise.then((result) => {
      const { data: { validations } } = result;
      this.processLoadedItem(result);
      this.validations = validations;

      if(!this.identifier) {
        this.item.key = "newItem";
      }
      else {
        this.item.key = this.item.updatedAt;
      }

      this.setState({
        formFields: this.formFields(validations),
        loading: false
      })
    })
    .catch((result) => {
      
      this.setState({
        loading: false
      });
      this.props.showServerErrorIfNeed(result);
    })
  }

  onItemChange(changedItem) {
    this.item = {
      ...this.item,
      ...changedItem
    };
  }

  onSubmit(event) {
    event.preventDefault();
    this.saveItem();
  }

  saveItem() {
    this.setState({
      submit: true,
      errorData: undefined
    });

    this.beforeSaveProcessing();
    
    this.saveUseCase.execute(this.identifier, this.item)
    .then((result) => {

      const { history } = this.props;

      this.processLoadedItem(result);

      if(`${this.identifier}` !== `${this.dataModel.value(this.item)}`) {
        history.replace(this.routeFunc(this.item));
      }
      else {
        this.setState({
          submit: false
        });
        this.forceUpdate();
      }
      this.afterSaveSuccess();
    })
    .catch((result) => {

      const { errorData } = result;
      this.setState({
        submit: false,
        errorData: errorData
      });
      this.props.showServerErrorIfNeed(result);

      this.afterSaveFail();
    })
  }

  beforeSaveProcessing() {

  }

  afterSaveSuccess() {
    this.props.showSuccessMessage(this.savedMessage(!this.identifier));
  }

  afterSaveFail() {

  }

  onDelete() {
    if(!this.deleteUseCase) {
      return;
    }
    this.props.showConfirmModal({
      title: this.deleteConfirmTitle(),
      message: this.deleteConfirmMessage(),
      onConfirm: this.onDeleteConfirmed
    })
  }

  onDeleteConfirmed() {
    const { history } = this.props;

    if(!this.deleteUseCase) {
      return;
    }
    this.setState({
      submit: true
    })
    this.deleteUseCase.execute(this.identifier)
    .then(() => {

      this.props.showSuccessMessage(this.deletedMessage());

      if(history.length > 2) {
        history.goBack()
      }
      else {
        history.replace(Routes.index())
      }
    })
    .catch((result) => {
      this.setState({
        submit: false,
      });
      this.props.showServerErrorIfNeed(result);
    })
  }

  onChangeTab(currentTab, tabInfo) {
    const { history } = this.props;
    const newItem = {
      hash: `#${currentTab}`
    };
    const { queryParams } = tabInfo;
    if(queryParams) {
      newItem.search = URLParams.constructSearch(queryParams);
    }
    history.replace(newItem);
    this.setState({
      currentTab: currentTab
    })
  }

  deleteConfirmTitle() {
    return I18n.t("shared.are_you_sure");
  }

  deleteConfirmMessage() {
    return "";
  }

  savedMessage(isNew) {
    return I18n.t("shared.toast.successfully_saved");
  }

  deletedMessage() {
    return I18n.t("shared.toast.successfully_deleted");
  }

  processLoadedItem(result) {
  }

  formFields() {
    return this.dataModel.formFields({
      item: this.item || {},
      validations: this.validations || {}
    });
  }

  header() {
    return <InfoPageHeader title = { this.pageTitle() }
                           subtitle = { this.pageSubtitle() } >
      { this.headerContent() }
    </InfoPageHeader>
  }

  pageTitle() {
    const { loading } = this.state;
    return !loading ? this.dataModel.displayValue(this.item) : ""
  }

  pageSubtitle() {
    return "";
  }

  headerContent() {
    return <React.Fragment />
  }

  content() {
    const { classes } = this.props;
    const { errorData, formFields } = this.state;
    return <Card className = { clsx(classes.pageData, classes.pageDataCard) } >
      <CardContent className = { classes.pageDataContent } >
        <FormFields formFields = { formFields } 
                    item = { this.item }
                    errorData = { errorData }
                    onItemChange = { this.onItemChange } 
                    defaultWeight = { 6 }
                    key = { this.item.key } />
      </CardContent>
    </Card>
  }

  buttons() {
    const { classes } = this.props;
    
    return <NavigationTabContent visible = { this.buttonsIsVisible() } >
      <Card className = { classes.formButtonsCard } >
        <CardContent className = { classes.formButtons } >
          <div className = { classes.formButtonsLeft } >
            { this.leftButtons() }
          </div>
          <div className = { classes.formButtonsSpacer } />
          <div className = { classes.formButtonsRight } >
            { this.rightButtons() }
          </div>
        </CardContent>
      </Card>
    </NavigationTabContent>
  }

  buttonsIsVisible() {
    return true;
  }

  leftButtons() {
    const { classes } = this.props;
    const { submit, loading } = this.state;

    return <React.Fragment>
      <Button className = { classes.button }
              type = { "submit" }
              disabled = { submit || loading } >
        { I18n.t("action.save") }
      </Button>
    </React.Fragment>
  }

  rightButtons() {
    return <React.Fragment />
  }

  render() {
    const { classes } = this.props;

    return <div className = { classes.page } 
                ref = { (ref) => this.scrollContainer = ref }
                onScroll = { () => {
                  const event = new Event("scroll");
                  window.dispatchEvent(event);
                }} >
      <div className = { classes.pageHeader } >
        { this.header() }
      </div>
      <div className = { classes.pageContent }
           ref = { (ref) => this.scrollContent = ref } >
        <form onSubmit = { this.onSubmit }
              className = { classes.form } >
          { this.content() }
          { this.buttons() }
        </form>
      </div>
    </div>
  }
}

BaseInfoPage.propTypes = {
  showUseCase: PropTypes.object.isRequired
}


export default BaseInfoPage;
export { infoPageStyles };